import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class ServiceSlide extends Component {
    render() {
        return (
            <div className="row-services">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="themesflat-spacer clearfix" data-desktop={81} data-mobile={60} data-smobile={60} />
                            <div className="themesflat-carousel-box data-effect clearfix" data-gap={30} data-column={3}
                                data-column2={2} data-column3={1} data-auto="true">
                                <div className="owl-carousel owl-theme">
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-1-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">DESIGN-BUILD</Link></h5>
                                                    <p className="letter-spacing-01">We develop and understand project expectations
                                                        and then manage those needs with a design [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-2-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">CONSTRUCTION MANAGEMENT</Link></h5>
                                                    <p className="letter-spacing-01">We work closely with architects to understand
                                                        the project, and ultimately develop a targeted [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-3-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">METAL BUILDING SERVICES</Link></h5>
                                                    <p className="letter-spacing-01">In the past decade alone, we have completed
                                                        more than 5 million square feet of metal [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-1-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">DESIGN-BUILD</Link></h5>
                                                    <p className="letter-spacing-01">We develop and understand project expectations
                                                        and then manage those needs with a design [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-2-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">CONSTRUCTION MANAGEMENT</Link></h5>
                                                    <p className="letter-spacing-01">We work closely with architects to understand
                                                        the project, and ultimately develop a targeted [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-3-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">METAL BUILDING SERVICES</Link></h5>
                                                    <p className="letter-spacing-01">In the past decade alone, we have completed
                                                        more than 5 million square feet of metal [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="themesflat-spacer clearfix" data-desktop={15} data-mobile={15} data-smobile={15} />
                            <div className="themesflat-carousel-box data-effect clearfix" data-gap={30} data-column={3}
                                data-column2={2} data-column3={1} data-auto="true">
                                <div className="owl-carousel owl-theme">
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-4-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">METAL BUILDING SERVICES</Link></h5>
                                                    <p className="letter-spacing-01">In the past decade alone, we have completed
                                                        more than 5 million square feet of metal building [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-5-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">PRECONSTRUCTION SERVICES</Link></h5>
                                                    <p className="letter-spacing-01">ASC Construction Services provides the right
                                                        resources and expertise to evaluate concepts [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-6-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">CONCRETE STRUCTURES</Link></h5>
                                                    <p className="letter-spacing-01">We employs a talented team of industry leading
                                                        professionals capable of self-performing [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-4-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">METAL BUILDING SERVICES</Link></h5>
                                                    <p className="letter-spacing-01">In the past decade alone, we have completed
                                                        more than 5 million square feet of metal building [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-5-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">PRECONSTRUCTION SERVICES</Link></h5>
                                                    <p className="letter-spacing-01">Autora Construction Services provides the right
                                                        resources and expertise to evaluate concepts [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="themesflat-image-box style-2 clearfix">
                                        <div className="image-box-item">
                                            <div className="inner">
                                                <div className="thumb data-effect-item">
                                                    <img src="assets/img/imagebox/image-box-6-370x215.jpg" alt="altimage" />
                                                    <div className="overlay-effect bg-color-accent" />
                                                </div>
                                                <div className="text-wrap">
                                                    <h5 className="heading"><Link to="#">CONCRETE STRUCTURES</Link></h5>
                                                    <p className="letter-spacing-01">We employs a talented team of industry leading
                                                        professionals capable of self-performing [...]</p>
                                                    <div className="elm-readmore">
                                                        <Link to="page-services-detail.html">DETAILS</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="themesflat-spacer clearfix" data-desktop={45} data-mobile={60} data-smobile={60} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ServiceSlide;